module.exports = __webpack_public_path__ + "boisson.png?f3da0c4e5f5198a5b90114e16fdefce5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/upload_images/offers/boisson.png
// module id = 104
// module chunks = 13